import React, { Component } from 'react';
import { getDmService } from '../../../../../services/Api';
import uniformsSteps from '../../../../../fixtures/adminClipboards.json';
import Cleark from '../../../../../components/trades/uniforms/Clerk';
import DataUniform from '../../../../../components/trades/uniforms/DataUniform';

class Detail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFinished: false,
      dataClerck: {},
      // clerk: null,
      selectedItemSearch: null,
      // optionsCleark: [],
      selectedUnit: null,
      selectedStore: null,
      stores: [],
    };
  }

  componentDidMount() {
    this.searchTradeTyped();
    this.selectedItens();
  }

  loadStores = async unitId => {
    const { data } = this.props;
    const idClerk = data.atendente.id;

    try {
      const updatedData = await getDmService(`/Atendente/GetLojas/${idClerk}?idUnidade=${unitId}`);
      const arrStores = [];
      updatedData.forEach(item => {
        arrStores.push({
          id: item.id,
          label: item.nome,
        });
      });

      this.setState({
        stores: arrStores,
      });
    } catch (error) {
      console.error(error);
    }
  };

  onChangeUnit = obj => {
    this.setState({
      selectedUnit: obj,
      selectedStore: null,
      // error: null,
    });

    if (obj) {
      this.loadStores(obj.id);
    }
  };

  onChangeStore = obj => {
    this.setState({
      selectedStore: obj,
      // error: null,
    });
  };

  searchTradeTyped(obj) {
    const { data } = this.props;
    const cleark = data.atendente || {};
    const search = obj ? obj.label : cleark.nome;
    const selected = { id: cleark.id, label: cleark.nome };
    const urlGet = `/Atendente/BuscaAtendentes/?busca=${search}&tipoAssistente=2`;
    this.setState({
      selectedItemSearch: obj || selected,
    });

    getDmService(urlGet)
      .then(res => {
        res.forEach(item => {
          this.setState({
            isFinished: true,
            cleark: obj,
            dataClerck: {
              id: item.id,
              name: item.nome,
              codLastRequest: item.codigoUltimoPedido,
              orderId: item.idUltimoPedido,
              codeOrder: item.codigoUltimoPedido,
              dateOrder: item.dataUltimoPedido,
              typeRequest: item.tipo,
            },
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  changeSelected = obj => {
    if (obj) {
      this.setState({ selectedItemSearch: obj /* , btnReturn: false */ }, () => {
        this.searchTradeTyped(obj);
      });
    } else {
      this.setState({
        selectedItemSearch: {},
        // showResults: false,
      });
    }
  };

  selectedItens = () => {
    const { data } = this.props;
    const dataUnitStore = data && data.itensAssistente.length ? data.itensAssistente[0].loja : [];

    this.setState({
      selectedUnit: { id: dataUnitStore.unidade.id, label: dataUnitStore.unidade.nomeFantasia },
      selectedStore: { id: dataUnitStore.id, label: dataUnitStore.nomeFantasia },
    });
  };

  renderComponent = step => {
    const { data } = this.props;
    // const uniformItem = data.itensAssistente;
    // const hasUniformnItem = uniformItem.length > 0;

    const {
      isFinished,
      dataClerck,
      cleark,
      selectedItemSearch,
      selectedUnit,
      selectedStore,
      stores,
    } = this.state;

    switch (step.form) {
      case 'atendente':
        return (
          <div key={step.id}>
            <Cleark
              isFinished={isFinished}
              dataClerck={dataClerck}
              data={data}
              cleark={cleark}
              selectedItemSearch={selectedItemSearch}
              changeSelected={this.changeSelected}
              selectedUnit={selectedUnit}
              selectedStore={selectedStore}
              stores={stores}
              onChangeUnit={this.onChangeUnit}
              onChangeStore={this.onChangeStore}
            />
          </div>
        );
      case 'uniforme':
        return (
          <div key={step.id}>
            <DataUniform data={data} />
          </div>
        );
      default:
        return null;
    }
  };

  render() {
    return <div>{uniformsSteps.map(item => this.renderComponent(item))}</div>;
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Clipboards/Detail/Detail.js